import React from 'react';
import { Button, ButtonProps } from 'components/ui_library/Button';
import { TextSmall } from 'components/Popover';
import { IconChevronDown, IconBuilding, IconUserCircle, IconChevronUp, IconGlobe } from 'components/Icons';
import { cx } from '@linaria/core';
import { workspaceItemSelectedStyled, workspaceItemStyled } from 'components/UniversalSearch/components/WorkspaceItem/WorkspaceItem.styled';
type WorkspaceItemProps = ButtonProps & {
  active?: boolean;
  onWorkspaceSelect?: (userOrOrgData: CF.LocalUserWithOrgUserAndPlan | CF.API.Organizations.UserOrganization) => void;
  userOrOrgData?: CF.LocalUserWithOrgUserAndPlan | CF.API.Organizations.UserOrganization;
  withArrow?: string;
};
const ICON_SIZE = 16;
const OrganizationItem: React.FC<WorkspaceItemProps> = ({
  active,
  onWorkspaceSelect,
  userOrOrgData,
  withArrow = '',
  ...rest
}) => {
  const userOrOrg = (userOrOrgData as CF.API.Organizations.UserOrganization);
  const onSelect = () => onWorkspaceSelect?.(userOrOrg);
  return <Button className={cx(workspaceItemStyled, active && workspaceItemSelectedStyled)} onClick={onSelect} size="md" variant="unstyled" {...rest}>
      <IconBuilding size={ICON_SIZE} />
      <TextSmall className="name">{userOrOrg.organization.name}</TextSmall>
      {withArrow === 'down' && <IconChevronDown />}
      {withArrow === 'up' && <IconChevronUp />}
    </Button>;
};
const UserItem: React.FC<WorkspaceItemProps> = ({
  withArrow = '',
  active,
  onWorkspaceSelect,
  userOrOrgData,
  ...rest
}) => {
  const userOrOrg = (userOrOrgData as CF.LocalUserWithOrgUserAndPlan);
  const onSelect = () => onWorkspaceSelect?.(userOrOrg);
  return <Button className={cx(workspaceItemStyled, active && workspaceItemSelectedStyled)} onClick={onSelect} size="md" variant="unstyled" {...rest}>
      <IconUserCircle size={ICON_SIZE} />
      <TextSmall className="name">{`${userOrOrg.first_name} ${userOrOrg.last_name}`}</TextSmall>
      {withArrow === 'down' && <IconChevronDown />}
      {withArrow === 'up' && <IconChevronUp />}
    </Button>;
};
const CommunityItem: React.FC<WorkspaceItemProps> = ({
  withArrow = '',
  active,
  onWorkspaceSelect,
  userOrOrgData,
  ...rest
}) => {
  const userOrOrg = (userOrOrgData as CF.LocalUserWithOrgUserAndPlan);
  const onSelect = () => onWorkspaceSelect?.(userOrOrg);
  return <Button className={cx(workspaceItemStyled, active && workspaceItemSelectedStyled)} onClick={onSelect} size="md" variant="unstyled" {...rest}>
      <IconGlobe size={ICON_SIZE} />
      <TextSmall className="name">Community</TextSmall>
      {withArrow === 'down' && <IconChevronDown />}
      {withArrow === 'up' && <IconChevronUp />}
    </Button>;
};
export const WorkspaceItem: React.FC<WorkspaceItemProps> = props => {
  if (!props.userOrOrgData) return <CommunityItem {...props} />;
  if ('organization' in props.userOrOrgData) return <OrganizationItem {...props} />;else return <UserItem {...props} />;
};